
<script>
import { defineComponent, computed, inject, onBeforeUnmount, ref } from 'vue'
import Scroller from '@kit/utils/Scroller'
import { pathname } from '@kit/utils/Formats'
import { inBrowser } from '@kit/utils/EnvironmentHelper'
import { useStore } from 'vuex'
import { sleep } from '@kit/utils/Sleep'
import Shine from '@kit/components/Shine.vue'
import { cmsasset } from '@kit/utils/Formats'
import '@css/index.css'
import Column from '@kit/components/Column.vue'
import Img from '@kit/components/Img.vue'
import Gallery2 from '@kit/components/gallery2/Gallery2.vue'
import { getEnv } from '@kit/utils/EnvironmentHelper'
import { blueButton } from '@project/themes'
import IconButton from '@kit/components/IconButton.vue'
import { GoogleMap, Marker, Polygon, InfoWindow } from 'vue3-google-map'

import { getProduct } from '@project/api/pay/v1'

import { cchdrvImgTheme, cchdrvGallery2Theme } from '@project/themes'

export default defineComponent({
  name: "Home",

  setup() {
    const hydrate = inject("hydrate")
    const themer = inject("themer")
    const cchdrvImgTheme_ = themer(cchdrvImgTheme)
    const cchdrvGallery2Theme_ = themer(cchdrvGallery2Theme)
    const blueButton_ = themer(blueButton)

    const { prefetch, P } = hydrate({
      prefetch:["home"],
      mounted() {
        
      },
      metadata(meta, { home }) {

        if(home.seo && home.seo.length > 0) {
          const seo = home.seo[0]
          meta.addTitle(seo.page_title)
          meta.addCanonical()
          meta.addMetaItem([
            {name: "theme-color", content:"#173d6f"},
            { name:'description', content: seo.page_description },
            { name:'og:title', content: seo.open_graph_title },
            { name:'og:description', content: seo.open_graph_description },
            { name:'og:image', content: cmsasset(seo.open_graph_image.guid) },
            { name:'og:image:alt', content: seo.open_graph_image_alt } 
          ])
        }
      }
    })


    const galleryOpen1 = ref(false)
    const index1 = ref(0)
    const galleryOpen2 = ref(false)
    const index2 = ref(0)

    const galleryData = (which) => {

      if(prefetch.value && prefetch.value.home && prefetch.value.home['section_'+which+'_pictures']) {

        const pics = prefetch.value.home['section_'+which+'_pictures']
        const items = []

        for(let i=0; i<pics.length; i++) {
          const pic = pics[i]
          const url = cmsasset(pic.image.guid)

          const alt = pic.aria_label 
          items.push({ url, alt, type:'image'})
        }

        return { items }
      } else {
        return { items:[] }
      }
    }

    const openGallery = (e, idx, which) => {
      e.preventDefault();
      if(which == 1) {
        index1.value = idx
        galleryOpen1.value = true
      } else 
      if(which == 2) {
        index2.value = idx
        galleryOpen2.value = true        
      }
    }


    const mapInfo = (location) => {
      if(!location) {
        throw new Error("No map info")
      }
      const loc = location   

      return { 
        center:{ lat: parseFloat(loc.lat), lng: parseFloat(loc.long) }, 
        mapType:loc.type_of_map, 
        zoom: parseFloat(loc.zoom) 
      }
    }


    onBeforeUnmount(() => {
      // scroller.destroy()
      // scroller = null
    })

    return { 
      cchdrvGallery2Theme_,
      blueButton_,
      galleryData,
      openGallery,
      galleryOpen1,
      index1,
      galleryOpen2,
      index2,

      cmsasset,
      pathname, 
      inBrowser, 
      cchdrvImgTheme_,
      prefetch,
      mapInfo,
      P,
      getEnv
    }
  },


  components: {
    Column,
    Img,
    Shine,
    Gallery2,
    IconButton,
    GoogleMap, Marker, Polygon, InfoWindow
  },
});
</script>

<style scoped>

  .display-title {
    text-align: center;
    color: white;
  }

  .section-margin-top {
    margin-top:50px !important;
  }

  .side-img {
    width: 200px !important;
  }
  .side-img2 {
    width: 200px !important;
  }
  @media (max-width:650px) {
    .side-img {
      width: 90px !important;
    }
  }
  @media (max-width:960px) {
    .side-img2 {
      align-self: center;
      width:300px !important;
    }
  }

</style>

<style>
  .vue-map-container {
    height:100%;
  }
</style>




<template>
 
  <main class="sb sb-v sb-greedy page-margin-top" role="main"> 

      <template v-if="prefetch && prefetch.home">

        <Column ltD="80" ltT="80" ltP="90" ltS="98" gtB="700" gtH="700" class="sb sb-v sb-g20" tag="article">

          <Img 
            class="sb sb-v"
            :wrapper="true" 
            width="100%"
            height="400px"
            display="fit"
            :theme="cchdrvImgTheme_" 
            :lgutter="45"
            :region="P(1, () => prefetch.home.header_image[0].theme_props, true).home.region"
            :fit="P(1).home.fit"
            :gutter="P(1).home.gutter"
            :aspect="P(1).home.aspect"
            :position="P(1).home.position"
            :ariaLabel="P(1).home.aria_label"

            :src="cmsasset(prefetch.home.header_image[0].image.guid)">
            
            <div aria-role="none" class="sb sb-spread" :style="prefetch.home.header_image_cover_css"></div>
            <h1 class="sb sb-text display-title"> {{ prefetch.home.display_title }}</h1>

          </Img>

        </Column>

        <Column ltD="60" ltT="70" ltP="90" ltS="98" gtB="700" gtH="700" class="sb sb-v sb-g20" tag="article">
      
          <h2 class="sb sb-text">{{ prefetch.home.intro_headline }}</h2>

          <p class="sb sb-text" v-html="prefetch.home.intro_main_text"></p>

          <div class="sb sb-h sb-greedy-1 sb-ltm-h2v sb-alt2 sb-align-cv sb-gr sb-g10 section-margin-top" style="padding:0px;">
            <div class="sb sb-greedy sb-v">
              <h2 class="sb sb-text">{{ prefetch.home.path_headline }}</h2>
              <p class="sb sb-text" v-html="prefetch.home.path_main_text"></p>
            </div>
            <Img 
              class="sb sb-explicit side-img2" 
              :display="P(4, () => prefetch.home.path_image[0].theme_props, true).home.display"
              :region="P(4).home.region"
              :fit="P(4).home.fit"
              :gutter="P(4).home.gutter"
              :aspect="P(4).home.aspect"
              :ariaLabel="P(4).home.ariaLabel" 
              :src="cmsasset(prefetch.home.path_image[0].image.guid)"/>
          </div>
        

          <div class="sb sb-h sb-greedy-1 sb-gr sb-g10 sb-alt2 sb-align-cv section-margin-top" style="padding:0px;">
            <div class="sb sb-greedy sb-v">
              <h2 class="sb sb-text">{{ prefetch.home.directions_headline }}</h2>
              <p class="sb sb-text" v-html="prefetch.home.directions_main_text"></p>
            </div>
            <Img class="sb sb-explicit side-img" 
              :display="P(3, () => prefetch.home.directions_image[0].theme_props, true).home.display"
              :region="P(3).home.region"
              :fit="P(3).home.fit"
              :gutter="P(3).home.gutter"
              :aspect="P(3).home.aspect"
              :ariaLabel="P(3).home.ariaLabel" 
              :src="cmsasset(prefetch.home.directions_image[0].image.guid)"/>
          </div>

          <div class="sb sb-v" style="height:500px;">
            <GoogleMap
              style="width:100%; height:100%;"
              :api-key="getEnv('GOOGLE_MAPS_NORMAL_API_KEY')"
              :center="P(2,() => mapInfo(prefetch.home.directions_google_map)).center"
              :zoom="P(2).zoom"
              :mapTypeId="P(2).mapType">
              <Polygon :options="{
                paths: [
                  { lat: 41.747991, lng: -124.181648 },
                  { lat: 41.748504, lng: -124.180912 },
                  { lat: 41.747976, lng: -124.180214 },
                  { lat: 41.748353, lng: -124.179755 },
                  { lat: 41.747831, lng: -124.178986 },
                  { lat: 41.746617, lng: -124.180504 },
                  { lat: 41.747726, lng: -124.181995 }
                ],
                strokeColor: '#2a559c',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#3a4bc9',
                fillOpacity: 0.35,
              }" />

              <Polygon :options="{
                paths: [
                  { lat: 41.747012, lng: -124.179264 },
                  { lat: 41.746191, lng: -124.178127 },
                  { lat: 41.745654, lng: -124.178978 },
                  { lat: 41.746386, lng: -124.180152 }
                ],
                strokeColor: '#2a559c',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#3a4bc9',
                fillOpacity: 0.35,
              }" />

              <InfoWindow :options="{ position: {lat:41.747767, lng:-124.180610}, content:'Bayside RV Spaces' }" />
              <InfoWindow :options="{ position: {lat:41.746350, lng:-124.179124}, content:'Redwood Harbor Village RV Spaces' }" />

            </GoogleMap>
            <!-- <GMapMap
                :center="P(2,() => mapInfo(prefetch.home.directions_google_map)).center"
                :zoom="P(2).zoom"
                :map-type-id="P(2).mapType">
              <GMapMarker
                :position="P(2).center"
              />
              <Polyline :options="{ paths:[
                  { lat: 37.772, lng: -122.214 },
                  { lat: 21.291, lng: -157.821 },
                  { lat: -18.142, lng: 178.431 },
                  { lat: -27.467, lng: 153.027 },
                ], 
                fillColor: '#FF0000' 
              }" />
            </GMapMap> -->
          </div>


          <h2 class="sb sb-text section-margin-top">{{ prefetch.home.section_1_headline }}</h2>

          <p class="sb sb-text" v-html="prefetch.home.section_1_main_text"></p>

          <Gallery2 :theme="cchdrvGallery2Theme_" :index="index1" :galleryData="galleryData(1)" v-model="galleryOpen1"/>

          <ul class="sb sb-h sb-gr" style="flex-wrap:wrap;">
            <li v-for="(pic, idx) in prefetch.home.section_1_pictures" @click="openGallery($event, idx, 1)" class="sb sb-explicit" style="width:25%; aspect-ratio:1/1; padding:10px;" aria-role="button" aria-label="open lightbox" aria-haspopup="dialog">
              <Img display="fit" fit="cover" :ariaLabel="pic.aria_label" :src="cmsasset(pic.image.guid)"/>
            </li>
          </ul>

          <!-- <IconButton :theme="blueButton_" tag="router-link" :to="'/availability/rhv-pull-thru'" text="Click to see availability"/>
       -->
          <IconButton href="https://bookingsus.newbook.cloud/ccharbor-reservations/index.php " :theme="blueButton_" text="Click to reserve a space"/>
  

          <h2 class="sb sb-text section-margin-top">{{ prefetch.home.section_2_headline }}</h2>

          <p class="sb sb-text" v-html="prefetch.home.section_2_main_text"></p>

          <Gallery2 :theme="cchdrvGallery2Theme_" :index="index2" :galleryData="galleryData(2)" v-model="galleryOpen2"/>

          <ul class="sb sb-h sb-gr" style="flex-wrap:wrap;">
            <li v-for="(pic, idx) in prefetch.home.section_2_pictures" @click="openGallery($event, idx, 2)" class="sb sb-explicit" style="width:25%; aspect-ratio:1/1; padding:10px;" aria-role="button" aria-label="open lightbox" aria-haspopup="dialog">
              <Img display="fit" fit="cover" :ariaLabel="pic.aria_label" :src="cmsasset(pic.image.guid)"/>
            </li>
          </ul>

          <!--
          <IconButton :theme="blueButton_" tag="router-link" :to="'/availability/bayside-pull-thru'" text="Click to see availability"/>
          -->
          <IconButton href="https://bookingsus.newbook.cloud/ccharbor-reservations/index.php " :theme="blueButton_" text="Click to reserve a space"/>
  

        </Column>

      </template>

      <template v-else>

        <Column ltD="80" ltT="80" ltP="90" ltS="98" gtB="700" gtH="700" class="sb sb-v sb-g20" tag="article">
        
          <div class="sb sb-v sb-align-alt2 sb-align-c" style="height:400px;">
            <Shine w="80%" padding="30px 80px 30px 80px" h="100px" min="300px" shine="dark" />
            <!-- <Shine w="80%" padding="50px 30px 30px 30px" h="200px" min="200px" shine="dark" /> -->
          </div>

        </Column>

      </template>

  </main>

</template>

